import { render, staticRenderFns } from "./DeleteUserDialog.vue?vue&type=template&id=562cfd37&"
import script from "./DeleteUserDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports